/**
 * Shared page primitives.
 */
export function PageHeader({ title, eyebrow, children }) {
  return (
    <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
      <div>
        {eyebrow && (
          <div className="text-[11px] uppercase tracking-[0.22em] text-stone-500 font-bold">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-4xl font-bold mt-1">{title}</h1>
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}

export function Panel({ title, action, children }) {
  return (
    <div className="panel">
      {(title || action) && (
        <div className="panel-header">
          <div className="font-display font-semibold">{title}</div>
          {action}
        </div>
      )}
      <div className="panel-body">{children}</div>
    </div>
  );
}

export function AllergenTags({ items }) {
  if (!items?.length) return <span className="text-stone-400 text-xs">—</span>;
  return (
    <div className="flex flex-wrap gap-1.5">
      {items.map((a) => (
        <span key={a} className="badge-allergen">
          {a}
        </span>
      ))}
    </div>
  );
}


/**
 * Compact staff-initials chip — the signature on a paper traveller.
 * Shows the first letter of each whitespace-separated token (max 3),
 * with the full name surfaced via tooltip.
 */
export function StaffInitials({ name, testId }) {
  if (!name) {
    return (
      <span className="text-stone-400 text-xs" data-testid={testId}>
        —
      </span>
    );
  }
  const initials = name
    .trim()
    .split(/\s+/)
    .slice(0, 3)
    .map((p) => p[0]?.toUpperCase() || "")
    .join("");
  return (
    <span
      className="inline-flex items-center justify-center h-7 min-w-[2rem] px-2 rounded-full bg-stone-100 border border-stone-300 text-stone-700 text-[11px] font-bold tracking-wider"
      title={`Signed by ${name}`}
      data-testid={testId}
    >
      {initials}
    </span>
  );
}
